<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="550" content-class="rounded-lg" scrollable>
			<v-card>
				<v-card-title class="text-body-1 text-md-h6">
					<span class="black--text text-uppercase font-weight-bold">Pilih Alamat</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<div class="py-2"><v-divider></v-divider></div>
					<v-row class="d-none d-md-flex">
						<v-col md="1"></v-col>
						<v-col md="3">
							<div class="text-body-2 font-weight-bold">Penerima</div>
						</v-col>
						<v-col md="8">
							<div class="text-body-2 font-weight-bold">Alamat Penerima</div>
						</v-col>
					</v-row>
					<div class="py-2 d-none d-md-block"><v-divider></v-divider></div>
					<v-row v-for="(address, index) in addressData" :key="index">
						<v-col cols="2" md="1" class="pb-0 pb-md-3">
							<v-radio-group class="mt-0" v-model="selectedAddress">
								<v-radio :value="address" class="small-check mt-0"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col cols="10" md="3" class="pb-0 pb-md-3">
							<div class="text-body-2 font-weight-bold">{{ address.user_address_receipt_name }}</div>
							<div class="pt-1 text-body-2">0987654321</div>
						</v-col>
						<v-col cols="2" class="d-block d-md-none"></v-col>
						<v-col cols="10" md="8" class="pt-0 pt-md-3">
							<div class="text-body-2 font-weight-bold">{{ address.user_address_name }}</div>
							<div class="pt-1 text-body-2">{{ addressText(address) }}</div>
						</v-col>
						<!-- <v-col md="3">
							<v-btn depressed color="grey lighten-1 white--text" class="text-body-2 rounded-lg text-capitalize font-weight-bold">Edit</v-btn>
							<v-btn depressed color="pink lighten-1 white--text" class="text-body-2 rounded-lg text-capitalize font-weight-bold ml-2">Hapus</v-btn>
						</v-col> -->
					</v-row>
				</v-card-text>
				<v-card-actions class="pt-4">
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="selectAddress" depressed class="text-capitalize font-weight-bold rounded-lg" height="45" width="150">Pilih</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			selectedAddress: {},
			dialog: false
		}
	},
	computed: {
		...mapState('addressKiriminaja', ['addressData']),
	},
	methods: {
		modalShow(address) {
			this.dialog = true
			this.selectedAddress = address
		},
		modalHide() {
			this.dialog = false
		},
		selectAddress() {
			this.$emit('action', this.selectedAddress)
			this.modalHide()
		},
		addressText(value) {
			var data = []
			if (value.user_address_detail)
				data.push(value.user_address_detail)
			if (value.user_address_subdistrict_name)
				data.push(value.user_address_subdistrict_name)
			if (value.user_address_city_name)
				data.push(value.user_address_city_name)
			if (value.user_address_province_name)
				data.push(value.user_address_province_name)
			return data.join(', ')
		},
	}
};
</script>